module.exports = __webpack_public_path__ + "static/media/outline-icons.701ae6ab.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/semantic/themes/default/assets/fonts/outline-icons.eot
// module id = 1630
// module chunks = 0